import React from "react";
import { Link } from "@/components/common/Link";
import { Separator } from "@/components/ui/separator";
import { Instagram, Cloud, Disc, Youtube } from "lucide-react";
import { WvcLogo } from '@/integrations/wordpress/WvcLogo';
const navigationLinks = [{
  label: "Home",
  path: "/HomePage"
}, {
  label: "About CJ",
  path: "/AboutCJPage"
}, {
  label: "Training",
  path: "\n"
}, {
  label: "Booking",
  path: "\n"
}, {
  label: "Shop",
  path: "\n"
}];
const socialLinks = [{
  icon: Instagram,
  label: "Instagram",
  href: "#"
}, {
  icon: Cloud,
  label: "TikTok",
  href: "#"
}, {
  icon: Disc,
  label: "Spotify",
  href: "#"
}, {
  icon: Youtube,
  label: "YouTube",
  href: "#"
}];
const legalLinks = [{
  label: "Privacy Policy",
  path: "#"
}, {
  label: "Terms of Service",
  path: "#"
}];
export default function FooterEcho() {
  return <footer data-section-id="155194" id="home-footer" className="dark bg-[#0a0a0a] text-white pt-12 md:pt-20 pb-6 px-4 md:px-6 lg:px-12 border-t border-white/5 relative overflow-hidden">
      {}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full max-w-3xl h-[1px] bg-gradient-to-r from-transparent via-[#ffb3d9]/20 to-transparent" />
      
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 md:gap-8 lg:gap-6 mb-8 md:mb-16">
          
          {}
          <div className="flex flex-col items-start justify-start">
            <Link to="/" className="inline-block transition-opacity hover:opacity-80">
              <WvcLogo className="h-6 md:h-7 w-auto" />
            </Link>
          </div>

          {}
          <div className="flex flex-col gap-6">
            <h4 className="font-sans font-bold text-xs tracking-widest uppercase text-white">
              Quick Links
            </h4>
            <nav className="flex flex-col gap-4">
              {navigationLinks.map((link, i) => <div key={link.label} data-index={i}>
                  <Link to={link.path} className="text-sm text-[#b3b3b3] hover:text-[#ffb3d9] transition-all duration-300 hover:drop-shadow-[0_0_8px_#ffb3d9] w-fit">
                    {link.label}
                  </Link>
                </div>)}
            </nav>
          </div>

          {}
          

          {}
          <div className="flex flex-col gap-6">
            <h4 className="font-sans font-bold text-xs tracking-widest uppercase text-white">
              Legal
            </h4>
            <nav className="flex flex-col gap-4">
              {legalLinks.map((link, i) => <div key={link.label} data-index={i}>
                  <Link to={link.path} className="text-sm text-[#b3b3b3] hover:text-[#ffb3d9] transition-all duration-300 hover:drop-shadow-[0_0_8px_#ffb3d9] w-fit">
                    {link.label}
                  </Link>
                </div>)}
            </nav>
          </div>

        </div>

        {}
        <div className="flex flex-col items-center w-full">
          <Separator className="w-full bg-white/10 mb-8" />
          <p className="text-[9px] md:text-[10px] font-sans text-[#b3b3b3] tracking-widest uppercase text-center">
            © 2024 CJ’s Circle. All Rights Reserved.
          </p>
        </div>
      </div>
    </footer>;
}